import { useGetAccessToken } from "./useGetAccessToken";
import { useRedirectToLogin } from "./useRedirectToLogin";
import { useRequestPasswordReset } from "./useRequestPasswordReset";
import { useSignOut } from "./useSignOut";
import { useSignUp } from "./useSignUp";

/** @deprecated - Use relevant hook(s) directly */
export const useAuth = () => {
  const getAccessToken = useGetAccessToken();
  const redirectToLogin = useRedirectToLogin();
  const requestPasswordReset = useRequestPasswordReset();
  const signOut = useSignOut();
  const signUp = useSignUp();

  return {
    getAccessToken,
    redirectToLogin,
    requestPasswordReset,
    signOut,
    signUp,
  };
};
